<template>
  <div id="system-journal-setting-general-setting">
    <div class="ipub-filter-div mar-b-20">
      <!-- <div class="ipub-filter-div-content"> -->
      <ipub-row :gutter="[12,16]">
        <ipub-col :span="4">
          <span class="ipub-p2 fw-bd line-h-40"
                style="display:inline-block;width:100px">Option Type</span>
          <ipub-select style="width:calc(100% - 100px)"
                       v-model="params.type"
                       placeholder="Choose Roles"
                       @change="getList()">
            <ipub-select-option v-for="(item,key) in optionType"
                                :value="key"
                                :key="key">
              {{item}}
            </ipub-select-option>
          </ipub-select>
        </ipub-col>
        <ipub-col :span="8">
          <site-search-group v-model.trim="params.keyword"
                             placeholder="Search by option name / other name"
                             @search="getList()"
                             @clear="handleClear" />
        </ipub-col>
      </ipub-row>
      <!-- </div> -->
    </div>
    <div>
      <div class="relative ipub-p1 line-h-40 mar-b-30">
        <div class="ipub-tab-list">
          <a :class="['ipub-p1','ipub-cursor-pointer','ipub-tab-list--tab',titleStatu===item.statu?'active':'']"
             v-for="(item,index) in titleTab"
             :key="item.title+index"
             @click="changeStatus(item)">{{item.title}}</a>
        </div>
        <div class="right-option">
          <ipub-button v-show="user.codeList&&user.codeList.includes('SYSTEM.PUBLISHER_SETTING.OPTION_SETTING.ADD')"
                       type="primary"
                       icon="iconAdd"
                       @click="add">
            Add a New Option
          </ipub-button>
        </div>
      </div>
      <ipub-table :columns="columns"
                  fixed
                  draggable
                  @drag="setSort"
                  :pagination="false"
                  :dataSource="dataSource">
        <template v-slot:time="{text,record}">
          <span v-if="text">{{ text?$moment(text).format('HH:mm  DD / MM / YYYY'): '- -' }}</span>
          <span v-else>{{$moment(record.createTime).format('HH:mm  DD / MM / YYYY')}}</span>
        </template>
        <template v-slot:email="{text}">
          {{text && text.email || '--'}}
        </template>
        <template v-slot:status="{text}">
          <template v-if="text">
            <ipub-label cover
                        style="width:80px"
                        type="success"
                        size="small">In Use</ipub-label>
          </template>
          <template v-else>
            <ipub-label cover
                        style="width:80px"
                        type="danger"
                        size="small">Unused</ipub-label>
          </template>
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip class="border-right"
                        v-show="user.codeList&&user.codeList.includes('SYSTEM.PUBLISHER_SETTING.OPTION_SETTING.EDIT')">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="edit(record)" />
          </ipub-tooltip>
          <template v-if="user.codeList&&user.codeList.includes('SYSTEM.PUBLISHER_SETTING.OPTION_SETTING.PUBLISH')">
            <ipub-tooltip v-if="record.enabled">
              <div slot="title">Unabled</div>
              <ipub-icon type="iconDisable"
                         @click="able(record)" />
            </ipub-tooltip>
            <ipub-tooltip v-else>
              <div slot="title">Abled</div>
              <ipub-icon type="iconAble"
                         @click="able(record)" />
            </ipub-tooltip>
          </template>
        </template>
      </ipub-table>
    </div>
    <add-dialog :isVisable="isVisable"
                :inputData="inputData"
                :type="params.type"
                @cancel="cancel"
                @confirm="confirm">

    </add-dialog>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
